<template>
  <div class="card mt-3 w-100" v-if="tibModel">
    <div class="row no-gutters">
      <div class="col-auto text-center mx-4">
        <a class="row mx-auto" :href="tibModel.url" target="_blank"
          ><img
            style="width:100px;height:100%;"
            :src="tibModel.imageUrl"
            class="mt-2"
        /></a>
        <img
          class="img-responsive"
          :src="'/tt/tib/' + tibModel.tag + '/qr.png?size=100'"
        />
      </div>
      <div class="col">
        <div class="card-block px-2 my-2">
          <h4 :class="[{ 'restricted': restrictedAccess }, 'card-title']">{{ tibModel && tibModel.name }}</h4>
          <div class="card-text">
            <div class="md" v-html="getHtml(tibModel)" />
          </div>
          <table class="formTable">
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>{{ tp.name }}:</td>
              <td v-if="!doEdit">{{ tibModel.name }}</td>
              <td v-if="doEdit">
                <input type="text" v-model="tibModel.name" />
              </td>
            </tr>
            <tr>
              <td>{{ tp.description }}:</td>
              <td v-if="!doEdit">{{ tibModel.description }}</td>
              <td v-if="doEdit"><textarea v-model="tibModel.description" /></td>
            </tr>
            <tr v-if="doEdit">
              <td></td>
              <td>
                <input
                  type="checkbox"
                  id="restrictedAccess"
                  v-model="restrictedAccess"
                />
                <label for="restrictedAccess">{{ tp.restrictedAccess }}</label>
              </td>
            </tr>
            <tr>
              <td>{{ tp.size }}:</td>
              <td>
                {{ tibModel && getReadableFileSizeString(tibModel.size) }}
              </td>
            </tr>
            <tr>
              <td>{{ tp.version }}:</td>
              <td>{{ new Date(tibModel.version).toISOString() }}</td>
            </tr>
          </table>

          <div v-if="!doEdit" class="mx-auto mt-3">
            <button @click="editMode(true)" class="btn btn-outline-dark mx-1">
              <i class="fas fa-edit"></i>&nbsp;Bearbeiten
            </button>
            <button @click="confirmDelete()" class="btn btn-outline-dark mx-1">
              <i class="far fa-trash-alt"></i>&nbsp;Löschen
            </button>
          </div>
          <div v-if="doEdit" class="mx-auto mt-3">
            <button @click="cancelEdit()" class="btn btn-outline-dark mx-1">
              <i class="far fa-times-circle"></i>&nbsp;Abbrechen
            </button>
            <button @click="updateTib()" class="btn btn-outline-dark mx-1">
              <i class="far fa-save"></i>&nbsp;Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
    <confirmDialog
      v-if="showConfirmDialog"
      ref="confirmDialog"
      :messageProperty="'Delete?'"
      @okdelete="okDelete"
      @canceldelete="cancelDelete"
      :tp="tp"
    ></confirmDialog>
  </div>
</template>

<script>
import { TT_URL } from "@/common/constants";
import axios from "axios";

import { getHtml, getReadableFileSizeString } from "@/common/utils";
import confirmDialog from "@/components/ConfirmDialog.vue";
export default {
  name: "tibDetails",
  components: {
    confirmDialog
  },
  data: function() {
    return {
      tibModel: null,
      showConfirmDialog: false,
      doEdit: false,
      oldName: "",
      oldDescription: "",
      restrictedAccess: true,
      getHtml: getHtml,
      getReadableFileSizeString: getReadableFileSizeString
    };
  },
  mounted() {
    this.tibModel = this.tibModelProperty;
    this.restrictedAccess = (this.tibModel.contentAccess === "Restricted");
  },
  watch: {
    tibModelProperty() {
      this.tibModel = this.tibModelProperty;
    }
  },
  methods: {
    editMode(on) {
      this.doEdit = on;
      if (on) {
        this.oldName = this.tibModel.name;
        this.oldDescription = this.tibModel.description;
      }
    },
    updateTib() {
      console.info("update tib");
      this.tibModel.contentAccess = (this.restrictedAccess ? "Restricted" : "Open");
      let self = this;
      axios
        .post(TT_URL + "/api/rest/tibtix/updateTib", this.tibModel)
        // eslint-disable-next-line
        .then(response => {
          console.info("saved");
          self.editMode(false);
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
      console.info("tibupdated");
      this.$emit("tibupdated");
    },
    cancelEdit() {
      this.tibModel.name = this.oldName;
      this.tibModel.description = this.oldDescription;
      this.editMode(false);
    },
    confirmDelete() {
      this.showConfirmDialog = true;
    },
    cancelDelete() {
      this.showConfirmDialog = false;
    },
    okDelete() {
      let self = this;
      axios
        .get(TT_URL + "/api/rest/tibtix/deleteTib/" + this.tibModel.tag)
        // eslint-disable-next-line
        .then(response => {
          console.info("deleted");
          this.$emit("tibdeleted", this.tibModel);
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
      this.showConfirmDialog = false;
    }
  },
  props: {
    tibModelProperty: Object,
    tp: Object
  }
};
</script>
